module.exports = __webpack_public_path__ + "static/img/banner_7.6998493.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner_7.png
// module id = H7MU
// module chunks = 1